import _ from 'lodash';
import { log } from '@swiper/core';
import Strategy from 'passport-custom';

export default function buildStationAuth() {
  return function stationAuth( app ) {
    const verifier = async ( req, done ) => {
      const station = req.params.station;
      if ( station ) {
        done( null, 'SYSTEM', { stationId : station.id } );
      } else {
        // done( new Error( `Not a station` ) );
        done();
      }
    };
    app.passport.use( 'station', new Strategy( verifier ) );
    app.passport.options( 'station', {} );
  };
}
